<template>
  <div class="app-wrapper" :class="{ hideSidebar: !sidebar.opened }">
    <div class="imgPic">
      <span
        class="demonstration"
        style="float: left; color: white; margin-left: 1%"
      >
        <img
          src="../../img/logoSchool.png"
          style="
            width: 200px;
            height: 50px;
            position: absolute;
            margin-top: 10px;
          "
        />
      </span>
      <span class="demonstration" style="float: right; margin-right: 1%">
        <span style="font-size: 14px; color: #f0f8ff">
          用户名：{{ name }} |
          <el-button type="text" @click="logout">
            <font color="#F0F8FF">退出登录</font>
          </el-button>
        </span>
      </span>
      <!-- <span class="demonstration" style="float:right;margin-right:3%">
				<div>
					<img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">
				</div>
			</span> -->
    </div>
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <div class="user-navbar">
        <navbar></navbar>
      </div>
      <div class="user-main">
        <app-main></app-main>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import AppMain from "./AppMain";
import config from "../../../config/config.js";
import { mapGetters } from "vuex";

export default {
  // name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  computed: {
    sidebar() {
      // sidebar.opened = true
      return this.$store.state.app.sidebar;
    },
    ...mapGetters([
      "sidebar",
      // 'name',
      "avatar"
    ])
  },
  data() {
    return {
      // name: "张三",
      name: JSON.parse(sessionStorage.getItem("user")).sysUser.realname
    };
  },
  methods: {
    logout() {
      this.$confirm("确认要退出登录吗", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          this.$router.push("/login");
        })
        .catch(action => {});
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;

  &.hideSidebar {
    .sidebar-container {
      width: 36px;
      overflow: inherit;
    }

    .main-container {
      margin-left: 36px;
      // margin-top: 60px;
    }
  }

  .sidebar-container {
    transition: width 0.28s ease-out;
    width: 210px;
    height: 93%;
    position: fixed;
    top: 70px;
    bottom: 0;
    left: 0;
    z-index: 1001;
    overflow-y: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .main-container {
    min-height: 100%;
    transition: margin-left 0.28s ease-out;
    margin-left: 210px;
    padding-top: 60px;
  }

  .imgPic {
    width: 100%;
    overflow: hidden;
    height: 70px;
    line-height: 70px;
    background-color: #0075b8;
    position: fixed;
    height: auto;
    overflow-y: auto;
    z-index: 1001;
  }

  .user-navbar {
    position: fixed;
    width: 100%;
    height: auto;
    overflow-y: auto;
    overflow: hidden;
    z-index: 1001;
    top: 70px;
  }

  .user-main {
    padding-top: 59px;
  }

  // .user-avatar {
  // 	width: 40px;
  // 	height: 40px;
  // 	border-radius: 10px;
  // }

  .user-avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    position: absolute;
    margin-top: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue